import { ServerMessagePayload } from '../api';

/**
 * Service for queuing custom (non-ECS) message payloads.
 *
 * Use this for application-level messages that don't correspond to
 * component mutations, such as:
 * - DialogueContentPayload
 * - GameTimeSyncPayload
 * - WhoAmIPayload
 *
 * The game loop collects payloads from two sources:
 * 1. World.flushPendingPayloads() - auto-generated ECS mutation payloads
 * 2. This queue (MessageQueueService) - custom application messages
 */
export class MessageQueueService {
  private queue: ServerMessagePayload[] = [];

  /**
   * Push a single payload to the queue.
   */
  push(payload: ServerMessagePayload): void {
    this.queue.push(payload);
  }

  /**
   * Push multiple payloads to the queue.
   */
  pushMany(payloads: ServerMessagePayload[]): void {
    this.queue.push(...payloads);
  }

  /**
   * Flush and return all pending payloads.
   * Clears the internal queue.
   */
  flush(): ServerMessagePayload[] {
    const payloads = this.queue;
    this.queue = [];
    return payloads;
  }

  /**
   * Get the current queue length (for debugging/testing).
   */
  get length(): number {
    return this.queue.length;
  }
}
